import React, { FC } from 'react';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import { SilentDialogProps } from './props';
import './styles.scss';

export const SilentDialog: FC<SilentDialogProps> = ({ className, iconWrapperClassName, icon, text }) => {
  return (
    <div className={classnames('silent-dialog', className)}>
      <div className={classnames('silent-dialog__icon', iconWrapperClassName)}>
        <Svg src={icon} />
      </div>

      <div className="silent-dialog__text">{text}</div>
    </div>
  );
};
